import {
  QueryEventRegistrationsArgs,
  QueryAutocompletePhysicalLocationsArgs,
  QueryGetPlaceDetailsArgs,
  QueryGenerateStaticMapUrlArgs,
  QueryEventRecurrencesArgs,
  QueryEventArgs,
  QueryEventsArgs,
  QueryCalendarInviteArgs,
} from '@tribeplatform/gql-client/types'
import {
  AutocompletePhysicalLocationResultFields,
  EventFields,
  EventRecurrenceFields,
  EventRegistrationFields,
  PlaceDetailsFields,
  StaticMapsFields,
} from '@tribeplatform/gql-client/types/generated'

import { KeyConstructor } from '../../utils/keys/keyConstructor.js'

const EVENT_KEY = 'event'
const EVENTS_KEY = 'events'
const EVENTS_LIST_KEY = 'eventsList'
const EVENTS_REGISTRATIONS_KEY = 'eventsRegistrations'
const CALENDAR_INVITE_KEY = 'calendarInvite'
const HAS_ONGOING_EVENTS_KEY = 'hasOngoingEvents'
const EVENT_LOCATIONS_KEY = 'autocompletePhysicalLocations'
const PLACE_DETAILS_KEY = 'placeDetails'
const STATIC_MAP_URL_KEY = 'staticMapUrl'
const EVENT_RECURRENCES_KEY = 'eventRecurrences'
const EVENT_ANALYTICS_KEY = 'eventsAnalytics'

export const getEventRecurrencesKey = KeyConstructor<
  QueryEventRecurrencesArgs,
  EventRecurrenceFields
>(EVENT_RECURRENCES_KEY)

export const getEventKey = KeyConstructor<QueryEventArgs>(EVENT_KEY)

export const getEventsKey = KeyConstructor<QueryEventsArgs>(EVENTS_KEY)

export const getEventsListKey = KeyConstructor<QueryEventsArgs, EventFields>(
  EVENTS_LIST_KEY,
)

export const getEventAnalyticsKey =
  KeyConstructor<QueryEventsArgs>(EVENT_ANALYTICS_KEY)

export const getEventRegistrationsKey = KeyConstructor<
  QueryEventRegistrationsArgs,
  EventRegistrationFields
>(EVENTS_REGISTRATIONS_KEY)

export const getCalendarInviteKey = KeyConstructor<
  QueryCalendarInviteArgs,
  string
>(CALENDAR_INVITE_KEY)

export const getHasOngoingEventsKey = KeyConstructor<QueryEventsArgs>(
  HAS_ONGOING_EVENTS_KEY,
)

export const getAutocompletePhysicalLocationsKey = KeyConstructor<
  QueryAutocompletePhysicalLocationsArgs,
  AutocompletePhysicalLocationResultFields
>(EVENT_LOCATIONS_KEY)

export const getPlaceDetailsKey = KeyConstructor<
  QueryGetPlaceDetailsArgs,
  PlaceDetailsFields
>(PLACE_DETAILS_KEY)

export const getStaticMapUrlKey = KeyConstructor<
  QueryGenerateStaticMapUrlArgs,
  StaticMapsFields
>(STATIC_MAP_URL_KEY)
